import { create } from 'zustand';

type Language = 'it' | 'es' | 'en';

interface LanguageStore {
  language: Language;
  setLanguage: (language: Language) => void;
}

export const useLanguage = create<LanguageStore>((set) => ({
  language: 'it',
  setLanguage: (language) => set({ language }),
}));